export const SmallLoadingSpinner = ({}) => <div className="loading-spinner-small"></div>;